import Pusher from 'pusher-js';

const pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY || '24ffd3cc7202c2f15380', {
  cluster: 'ap1'
});

export default pusher;